import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AppErrorBoundary from './AppErrorBoundary';
import './index.css';
import './styles/mobileUsability.css';

// Chrome can emit this harmless notification while a popover repositions during
// layout. In development, the Webpack overlay treats it as a full app error.
// Stop only this browser notification; genuine runtime errors still surface.
window.addEventListener('error', (event) => {
  if (!String(event.message || '').includes('ResizeObserver loop completed with undelivered notifications')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <React.StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </React.StrictMode>,
    rootElement
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </React.StrictMode>,
    rootElement
  );
}
